"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerTagSchema = void 0;
const base_1 = require("../base");
exports.CustomerTagSchema = base_1.BaseSchema.extend({
    name: base_1.ShortStringSchema,
    color: base_1.ShortStringSchema.optional(),
});
//# sourceMappingURL=tag.js.map